import React, { useMemo, useState } from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Stack,
  HStack,
  Heading,
  Input,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  IconButton,
  Button,
  useToast,
  CircularProgress,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";
import { MdArrowRight, MdArrowLeft, MdFileDownloadDone } from "react-icons/md";
import { getCamiones, getSandcubes } from "../../helpers/api.helper";
import {
  crearSandcubesPlanificacion,
  editarPlanificacion4,
} from "../../helpers/api.helper";
import { useEffect } from "react";

const EditarCamionesSandcubes = (props) => {
  const { seleccionado, initPlan, user } = props;
  const [sandcubs, setSandcubs] = useState([]);
  const [sandcubesSeleccionados, setSandcubesSeleccionados] = useState([]);
  const [camionesSeleccionados, setCamionesSeleccionados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterSandCube, setFilterSandCube] = useState("");
  const [camiones, setCamiones] = useState([]);
  const [camionesGuardados, setCamionesGuardados] = useState([]);
  const [sandcubesGuardados, setSandcubesGuardados] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [filterBy, setFilterBy] = useState({
    dominio: "",
    empresa: "",
  });
  const toast = useToast();

  const fetchInitialData = async () => {
    try {
      const { data: camionesResponse } = await getCamiones();
      const { data: sandcubesResponse } = await getSandcubes();

      setCamiones(
        camionesResponse.filter(
          ({ empresaTransportista }) => empresaTransportista.habilitado
        )
      );
      setSandcubs(sandcubesResponse);
    } catch (error) {
      toast({
        status: "error",
        isClosable: true,
        title: "Error al cargar los datos",
        duration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSeleccionados = ({ sandcube, isSelected }) => {
    if (isSelected) {
      setSandcubesSeleccionados([...sandcubesSeleccionados, sandcube]);
    } else {
      const sandcubesFiltrados = sandcubesSeleccionados.filter(
        (item) => item.idSandCube !== sandcube.idSandCube
      );
      setSandcubesSeleccionados(sandcubesFiltrados);
    }
  };

  // const handleLista = (e) => {
  //   setSandcubesSeleccionados(
  //     sandcubesSeleccionados.filter(
  //       (items) => items.idSandCube !== e.idSandCube
  //     )
  //   );
  //   setSandcubs([...sandcubs, e]);
  // };

  const sandcubesList = useMemo(() => {
    let sandcubesNoSeleccionados = [];
    let sandcubesFiltrados = [];

    if (sandcubesSeleccionados.length > 0) {
      sandcubesNoSeleccionados = sandcubs.filter(
        (obj1) =>
          !sandcubesSeleccionados.some(
            (obj2) => obj2.idSandCube === obj1.idSandCube
          )
      );
    } else {
      sandcubesNoSeleccionados = sandcubs;
    }
    if (!filterSandCube) {
      return sandcubesNoSeleccionados;
    } else {
      let filtrado = filterSandCube.toUpperCase().trim();

      sandcubesFiltrados = sandcubesNoSeleccionados.filter((element) => {
        return element.nombreSandCube
          .toString()
          .toUpperCase()
          .trim()
          .includes(filtrado);
      });

      return sandcubesFiltrados;
    }
  }, [filterSandCube, sandcubesSeleccionados, sandcubs]);

  const camionesList = useMemo(() => {
    let camionesNoSeleccionados = [];
    let camionesFiltrados = [];

    if (camionesSeleccionados.length > 0) {
      camionesNoSeleccionados = camiones.filter(
        (camion) =>
          !camionesSeleccionados.some(
            (camionSeleccionado) =>
              camionSeleccionado.idCamion === camion.idCamion
          )
      );
    } else {
      camionesNoSeleccionados = camiones;
    }

    if (Object.values(filterBy).every((value) => !value)) {
      return camionesNoSeleccionados;
    } else if (filterBy.dominio) {
      let filtrado = filterBy.dominio.toUpperCase();

      camionesFiltrados = camionesNoSeleccionados.filter((element) => {
        return element.dominio.toUpperCase().includes(filtrado);
      });

      return camionesFiltrados;
    } else {
      let filtrado = filterBy.empresa.toUpperCase();

      camionesFiltrados = camionesNoSeleccionados.filter((element) => {
        return element.empresaTransportista.nombreEmpresaT
          .toUpperCase()
          .includes(filtrado);
      });

      return camionesFiltrados;
    }
  }, [filterBy, camionesSeleccionados, camiones]);

  const handleSeleccionadosCamion = ({ camion, isSelected }) => {
    // setCamiones(camiones.filter((item) => item.idCamion !== camion.idCamion));
    if (isSelected) {
      setCamionesSeleccionados([...camionesSeleccionados, camion]);
    } else {
      const camionesFiltrados = camionesSeleccionados.filter(
        (item) => item.idCamion !== camion.idCamion
      );
      setCamionesSeleccionados(camionesFiltrados);
    }
  };

  const loadingtable = () => {
    return (
      <HStack w="100%" placeContent="center">
        <CircularProgress isIndeterminate color="brand.naranja" />
      </HStack>
    );
  };

  const handleCloseModal = () => {
    setCamionesGuardados([]);
    setSandcubesGuardados([]);
    setSandcubesSeleccionados([]);
    setCamionesSeleccionados([]);
    onClose();
  };

  const handleSubmitCamiones = async () => {
    setLoading(true);
    if (camionesGuardados.length > 0) {
      let idparsed = camionesGuardados.map((element) => {
        return { idCamion: element.idCamion };
      });

      let res = await editarPlanificacion4({
        editCamion: true,
        id: seleccionado.idPlanificacion,
        camion: idparsed,
      });

      if (res.status === 200) {
        toast({
          status: "success",
          isClosable: true,
          title: "Camiones editados correctamente",
          duration: 3000,
        });
      } else {
        setLoading(false);
        return toast({
          status: "error",
          isClosable: true,
          title: "Error al editar camiones",
          duration: 3000,
        });
      }

      initPlan();
      handleCloseModal();
    }
    setLoading(false);
  };

  const handleSubmitSandcubes = async () => {
    setLoading(true);

    if (sandcubesGuardados.length > 0) {
      let parsedSandcubes = sandcubesGuardados.map((e) => {
        return {
          idPlanificacion: seleccionado.idPlanificacion,
          idSandCube: e.idSandCube,
        };
      });

      let res = await crearSandcubesPlanificacion({
        idPlanificacion: seleccionado.idPlanificacion,
        sandCubes: parsedSandcubes,
      });

      if (res.status === 200) {
        toast({
          status: "success",
          isClosable: true,
          title: "Sandcubes editados correctamente",
          duration: 3000,
        });
      } else {
        setLoading(false);
        return toast({
          status: "error",
          isClosable: true,
          title: "Error al editar Sandcubes",
          duration: 3000,
        });
      }

      initPlan();
      handleCloseModal();
    }
    setLoading(false);
  };

  const handleOpen = () => {
    onOpen();
    if (seleccionado.scAsociados) {
      setSandcubesSeleccionados(seleccionado.scAsociados);
    } else {
      setSandcubesSeleccionados([]);
    }
    if (seleccionado.camiones) {
      setCamionesSeleccionados(seleccionado.camiones);
    } else {
      setCamionesSeleccionados([]);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  return (
    <>
      <Button onClick={handleOpen} variant={"link"}>
        Editar Camiones/Sandcubes
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={handleCloseModal}
        scrollBehavior={"inside"}
        size={"6xl"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <Tabs isFitted variant="enclosed">
              <TabList>
                <Tab>Camiones</Tab>
                <Tab>Sandcubes</Tab>
              </TabList>

              <TabPanels>
                <TabPanel>
                  {loading && loadingtable()}
                  {!loading && camiones.length >= 1 && (
                    <Stack w="100%">
                      <Stack w={"100%"}>
                        <HStack>
                          <Stack w={"50%"}>
                            <HStack>
                              <Heading size="md">Lista de Camiones</Heading>
                              <Input
                                w="130px"
                                type="text"
                                value={filterBy.dominio}
                                placeholder={`Buscar por dominio`}
                                onChange={(e) => {
                                  setFilterBy((prevstate) => ({
                                    ...prevstate,
                                    dominio: e.target.value,
                                  }));
                                }}
                                variant="flushed"
                                size={"sm"}
                              />
                              <Input
                                w="130px"
                                type="text"
                                value={filterBy.empresa}
                                placeholder={`Buscar por empresa`}
                                onChange={(e) => {
                                  setFilterBy((prevstate) => ({
                                    ...prevstate,
                                    empresa: e.target.value,
                                  }));
                                }}
                                variant="flushed"
                                size={"sm"}
                              />
                            </HStack>
                            <TableContainer
                              w={"100%"}
                              h={"calc(100vh - 350px)"}
                              overflowY="scroll"
                            >
                              <Table size="sm" variant="simple">
                                <Thead>
                                  <Tr>
                                    <Th>Dominio</Th>
                                    <Th>Interno</Th>
                                    <Th>Empresa</Th>
                                    <Th></Th>
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {camionesList?.map((camion) => (
                                    <Tr key={camion.idCamion}>
                                      <Td>{camion.dominio}</Td>
                                      <Td>{camion.nombreCamion}</Td>
                                      <Td>
                                        {
                                          camion.empresaTransportista
                                            .nombreEmpresaT
                                        }
                                      </Td>
                                      <Td>
                                        <IconButton
                                          variant="link"
                                          icon={<MdArrowRight />}
                                          onClick={() => {
                                            handleSeleccionadosCamion({
                                              camion,
                                              isSelected: true,
                                            });
                                          }}
                                          _hover={{ color: "brand.naranja" }}
                                        />
                                      </Td>
                                    </Tr>
                                  ))}
                                </Tbody>
                              </Table>
                            </TableContainer>
                          </Stack>
                          <Stack w={"50%"}>
                            <Heading size="md">Seleccionados</Heading>
                            <TableContainer
                              w={"100%"}
                              h={"calc(100vh - 350px)"}
                              overflowY="scroll"
                            >
                              <Table size="sm" variant="simple">
                                <Thead>
                                  <Tr>
                                    <Th></Th>
                                    <Th>Dominio</Th>
                                    <Th>Interno</Th>
                                    <Th>Empresa</Th>
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {camionesSeleccionados.map((camion) => (
                                    <Tr key={camion.idCamion}>
                                      <Td>
                                        <IconButton
                                          variant="link"
                                          icon={<MdArrowLeft />}
                                          onClick={() => {
                                            handleSeleccionadosCamion({
                                              camion,
                                              isSelected: false,
                                            });
                                          }}
                                          _hover={{ color: "brand.naranja" }}
                                        />
                                      </Td>
                                      <Td>{camion.dominio}</Td>
                                      <Td>{camion.nombreCamion}</Td>
                                      <Td>
                                        {
                                          camion.empresaTransportista
                                            .nombreEmpresaT
                                        }
                                      </Td>
                                    </Tr>
                                  ))}
                                </Tbody>
                              </Table>
                            </TableContainer>
                          </Stack>
                        </HStack>
                      </Stack>
                      <HStack w="100%" justifyContent="space-between">
                        <Button
                          bg={"red"}
                          color={"white"}
                          onClick={handleCloseModal}
                          isDisabled={loading}
                          _hover={{ opacity: 0.5 }}
                          placeSelf={"end"}
                        >
                          Cancelar
                        </Button>
                        <Stack>
                          <Button
                            bg={"brand.naranja"}
                            color={"white"}
                            variant="solid"
                            onClick={() => {
                              setCamionesGuardados(camionesSeleccionados);
                              toast({
                                status: "success",
                                isClosable: true,
                                title: "Camiones guardados correctamente",
                                duration: 1500,
                              });
                            }}
                            isDisabled={loading || user.idRol === "usuarioIT"}
                            _hover={{ bg: "white", color: "brand.naranja" }}
                          >
                            Guardar
                          </Button>
                          <Button
                            color="brand.naranja"
                            fontSize={12}
                            letterSpacing={1}
                            border="1px solid orange"
                            variant="outline"
                            leftIcon={<MdFileDownloadDone fontSize="20px" />}
                            textColor="brand.naranja"
                            onClick={() => {
                              handleSubmitSandcubes();
                              handleSubmitCamiones();
                            }}
                            isDisabled={
                              camionesGuardados.length < 1 ||
                              loading ||
                              user.idRol === "usuarioIT"
                            }
                            _hover={{ bg: "white", color: "brand.naranja" }}
                          >
                            Finalizar
                          </Button>
                        </Stack>
                      </HStack>
                    </Stack>
                  )}
                  {!loading && camiones.length < 1 && (
                    <Heading textAlign={"center"} size={"md"}>
                      No hay datos para mostrar
                    </Heading>
                  )}
                </TabPanel>
                <TabPanel>
                  {loading && loadingtable()}
                  {!loading && sandcubs.length >= 1 && (
                    <Stack w="100%">
                      <HStack w="100%">
                        <Stack w="50%">
                          <HStack>
                            <Heading size="md">Lista de Sandcubes</Heading>
                            <Input
                              w="150px"
                              type="text"
                              value={filterSandCube}
                              placeholder={`Buscar`}
                              onChange={(e) => {
                                setFilterSandCube(e.target.value);
                              }}
                              variant="flushed"
                              size={"sm"}
                            />
                          </HStack>
                          <TableContainer
                            w={"100%"}
                            h={"calc(100vh - 350px)"}
                            overflowY="scroll"
                          >
                            <Table size="sm" variant="simple">
                              <Thead>
                                <Tr>
                                  <Th>ID Sandcube</Th>
                                  <Th>Malla</Th>
                                  <Th></Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {sandcubesList.map((sandcube) => (
                                  <Tr key={sandcube.idSandCube}>
                                    <Td>{sandcube.nombreSandCube}</Td>
                                    <Td>{sandcube.malla}</Td>
                                    <Td>
                                      <IconButton
                                        variant="link"
                                        icon={<MdArrowRight />}
                                        onClick={() => {
                                          handleSeleccionados({
                                            sandcube,
                                            isSelected: true,
                                          });
                                        }}
                                        _hover={{ color: "brand.naranja" }}
                                      />
                                    </Td>
                                  </Tr>
                                ))}
                              </Tbody>
                            </Table>
                          </TableContainer>
                        </Stack>
                        <Stack w="50%">
                          <Heading size="md">Seleccionados</Heading>
                          <TableContainer
                            h={"calc(100vh - 350px)"}
                            overflowY="scroll"
                          >
                            <Table size="sm" variant="simple">
                              <Thead>
                                <Tr>
                                  <Th></Th>
                                  <Th>ID Sandcube</Th>
                                  <Th>Malla</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {sandcubesSeleccionados.map((sandcube) => (
                                  <Tr key={sandcube.idSandCube}>
                                    <Td>
                                      <IconButton
                                        variant="link"
                                        icon={<MdArrowLeft />}
                                        onClick={() => {
                                          handleSeleccionados({
                                            sandcube,
                                            isSelected: false,
                                          });
                                        }}
                                        _hover={{ color: "brand.naranja" }}
                                      />
                                    </Td>
                                    <Td>{sandcube.nombreSandCube}</Td>
                                    <Td>{sandcube.malla}</Td>
                                  </Tr>
                                ))}
                              </Tbody>
                            </Table>
                          </TableContainer>
                        </Stack>
                      </HStack>
                      <HStack w="100%" justifyContent={"space-between"}>
                        <Button
                          bg={"red"}
                          color={"white"}
                          onClick={onClose}
                          isDisabled={loading}
                          _hover={{ opacity: 0.5 }}
                          placeSelf={"end"}
                        >
                          Cancelar
                        </Button>
                        <Stack>
                          <Button
                            bg={"brand.naranja"}
                            color={"white"}
                            variant="solid"
                            onClick={() => {
                              setSandcubesGuardados(sandcubesSeleccionados);
                              toast({
                                status: "success",
                                isClosable: true,
                                title: "Sandcubes guardados correctamente",
                                duration: 1500,
                              });
                            }}
                            isDisabled={loading || user.idRol === "usuarioIT"}
                            _hover={{ bg: "white", color: "brand.naranja" }}
                          >
                            Guardar
                          </Button>
                          <Button
                            color="brand.verde"
                            fontSize={12}
                            letterSpacing={1}
                            border="1px solid orange"
                            variant="outline"
                            leftIcon={<MdFileDownloadDone fontSize="20px" />}
                            textColor="brand.naranja"
                            form="FormularioPlanificacion"
                            onClick={() => {
                              handleSubmitSandcubes();
                              handleSubmitCamiones();
                            }}
                            isDisabled={
                              sandcubesGuardados.length < 1 ||
                              loading ||
                              user.idRol === "usuarioIT"
                            }
                            _hover={{ bg: "white", color: "brand.naranja" }}
                          >
                            Finalizar
                          </Button>
                        </Stack>
                      </HStack>
                    </Stack>
                  )}
                  {!loading && sandcubs.length < 1 && (
                    <Heading textAlign={"center"} size={"md"}>
                      No hay datos para mostrar
                    </Heading>
                  )}
                </TabPanel>
              </TabPanels>
            </Tabs>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default EditarCamionesSandcubes;
